import React from "react";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";

import { ProgramProfileDto } from "@growth-machine-llc/stridist-api-client";
import { HeaderButton } from "../button/HeaderButton";
import { UserPlus } from "lucide-react";
import { useEnrollClients } from "./useEnrollClients";

export interface EnrollActionProps {
  disabled?: boolean;
  program: ProgramProfileDto;
  clientsCount: number;
  groupsCount: number;
}

const useStyles = makeStyles((theme) => ({
  button: {
    minWidth: theme.spacing(20),
    borderRadius: theme.spacing(0.5),
    fontSize: 16,
    fontWeight: 700,
    whiteSpace: "nowrap",
    padding: theme.spacing(0.75, 5.5),
  },
}));

export function EnrollAction(props: EnrollActionProps) {
  const { disabled = false, program, clientsCount, groupsCount } = props;
  const { openEnroll, dialogs } = useEnrollClients(
    program,
    clientsCount,
    groupsCount,
  );

  return (
    <>
      <HeaderButton
        startIcon={<UserPlus />}
        children="Enroll clients"
        onClick={openEnroll}
        disabled={disabled}
      />
      {dialogs}
    </>
  );
}
